export default __webpack_public_path__ + "static/media/smart_assistant_green.67aad6b8.png";